import styled, { css } from 'styled-components';
import { rem } from 'polished';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const ColStyled = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let thisMarginTop = 0;
    let thisHorizontalPadding = rem(30);

    if(xlargeUp){
      thisMarginTop = rem(50);
    }else if(largeUp){
      thisMarginTop = rem(35);
    }else if(mediumUp){
      thisMarginTop = rem(20);
    }

    if(mediumUp){
      thisHorizontalPadding = 0;
    }else if(smallUp){
      thisHorizontalPadding = rem(50);
    }

    return css`
      margin-top: ${thisMarginTop};
      margin-bottom: ${mediumUp ? 0 : rem(12)};
      margin-left: auto;
      margin-right: auto;
      padding-left: ${thisHorizontalPadding};
      padding-right: ${thisHorizontalPadding};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const largeUp = theme.largeUp();
    return css`
      ${largeUp && 'padding-top: 0;'};
    `;
  }}
`;

export const FieldsetStyled = styled.fieldset`
  padding: 0;
  border: none;
`;

export const LegendStyled = styled.legend`
  display: none;
`;